import ItemsCollection, { Item } from './ItemsCollection';

import Axios from 'axios';
import Module from './Module';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class ServiceModuleItem extends Item implements ICatalogueCategory {
  id!: number | null;
  moduleId!: number | null;
  name!: string;
  active!: boolean;
  menu!: boolean;
  summary!: string;
  slug!: string | null;
  imageId!: number | null;
  imageType!: string | null;
  erpId!: number | null;
  children!: any[];
  parentId!: number | null;
  sort!: number;
}

export class ServiceItemsCollection extends ItemsCollection<ServiceModuleItem> {
  model() {
    return ServiceModuleItem;
  }

  url(): string {
    return this.module.url();
  }

  getMovies() {
    return axiosInstance.get(this.url())
      .then((response) => response.data);
  }

}

export default class ServiceModule extends Module<ServiceItemsCollection> {

  routeName = 'service';

  Collection() {
    return ServiceItemsCollection;
  }

  url() {
    return `/catalogues/${this.id}`;
  }

  urlItem() {
    return `${this.url()}/catalogue`;
  }

  urlCategory() {
    return `${this.url()}/categories`;
  }

  urlItems() {
    return `${this.url()}/items`;
  }

  fetchImageById(id: any) {
    return axiosInstance.get(`${this.urlItem()}/image/${id}`)
    .then((response) => {
      return response.data;
    }).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  updateCategory(id: any, data: any) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}`, data)
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  getSpecificCategory(id: number|string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}`)
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  // dprecated by getAllCategories?
  fetchCategoryData(index: number | null = null, search: string | null = null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (search && index) {
      return axiosInstance.get(`${this.urlCategory()}?search=${search}&page=${index}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
          .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
    } else if (!search && index) {
      return axiosInstance.get(`${this.urlCategory()}?page=${index}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.urlCategory()}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  getAllCategories() {
    if (cancel !== undefined) {
      cancel();
    }
    return axiosInstance.get(`${this.urlCategory()}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });

  }

  fetchData(index: number = 1, search: string | null, perpage: number | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (search) {
      return axiosInstance.get(`${this.urlItems()}?search=${search}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.urlItems()}?page=${index}&perpage=${perpage}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  createNewItem(item: any) {
    console.log(item);
    return axiosInstance.post(`${this.urlItem()}`, item)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }
  detachCategoryFromPage(page: ICatalogueItem, n: any) {
    return axiosInstance.post(`${this.urlItem()}/${page.id}/detach`, {name: n.tag.text})
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCategoryToPage(page: ICatalogueItem, n: any) {
    return axiosInstance.post(`${this.urlItem()}/${page.id}/attach`, {name: n.tag.text})
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}/unattached?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  detachGallery(id: number, imageId: number) {
    return axiosInstance.post(`${this.urlItem()}/${id}/detach/gallery`, {id: imageId})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  attachGallery(id: number, imageId: number) {
      return axiosInstance.post(`${this.urlItem()}/${id}/attach/gallery`, {id: imageId})
      .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Catalogue',
            message: e,
          };
          generateLog(log);
        });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.urlItem()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.urlItem()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  updateItem(id: number, page: any) {
    return axiosInstance.put(`${this.urlItem()}/${id}`, page)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  getItem(id: number) {
    return axiosInstance.get(`${this.urlItem()}/${id}`)
    .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewCategory(cat: ICatalogueCategory) {
    return axiosInstance.post(`${this.urlCategory()}`, {category: cat})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }
  createRootCategory(cat: ICatalogueCategory, id: string) {
    return axiosInstance.post(`${this.urlCategory()}/root`, {parent: Number(id), category: cat})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteCategory(id: number) {
    return axiosInstance.delete(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  sortCategories(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  sortMovies(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlItem()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  getCatalogueCategories() {
    return axiosInstance.get(this.urlCategory())
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  editCatalogueCategory(cat: ICatalogueCategory) {
    return axiosInstance.put(`${this.urlCategory()}/${cat.id}`, cat)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  getSubItems(id: number, search: string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}/content?search=${search}`)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  import(data: any, tableName: string, id: any) {
    return axiosInstance.post(`import/${tableName}?type=module&module_id=${id}`, {data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }

  export(tableName: string, id: any) {
    return axiosInstance.get(`export/${tableName}?type=module&module_id=${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }
  updatedLinkModules(item: any) {
    console.log(item);
    return axiosInstance.post(`update/linkmodules`, item)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Catalogue',
          message: e,
        };
        generateLog(log);
      });
  }
}

export class CatalogueItem extends Item implements ICatalogueItem {
  moduleId!: number;
  name!: '';
  subname!: null;
  slug!: null;
  content!: string;
  active!: boolean;
  menuTitle!: string;
  imageId!: null;
  imagType!: string | null;
  summary!: string;
  gallery!: IMediaItem[];
  categories!: ICatalogueCategory[];
  parentId!: null;
  title!: null;
  price!: '';
  currency!: '';
  taxes!: false;
  shortDescription!: string | null;
  description!: string;
  showDescription!: boolean | false;
  orderable!: boolean | false;
  bookable!: boolean | false;
  orderDestination!: string | null;
  orderEmailTo!: string | null;
  deliveryOptions!: string | null;
  from!: any | null;
  to!: any | null;
  noDateLimit!: boolean | false;
  packages!: IPackage[];
  pmsId!: string | null;
  posId!: string | null;
  sort!: number | null;
  tags!: string[];
  productType!: string;
  vendor!: string | null;

  url() {
    return `/catalogues/${this.id}`;
  }

  urlItem() {
    return `${this.url()}/page`;
  }

}
